import { throttle } from 'lodash';
import { MouseEvent, ReactNode } from 'react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './Resizable.css';

export interface ResizableProps {
    left: (relativeWidth: number) => ReactNode;
    right: (relativeWidth: number) => ReactNode;
    minLeft: number;
    minRight: number;
}

const BLOCK = 'resizable';

export class Resizable extends React.Component<ResizableProps> {
    static defaultProps: Partial<ResizableProps> = {
        minLeft: 100,
        minRight: 100
    };

    state = {
        isResizing: false,
        rightRelativeWidth: 0.5
    };

    containerRef = React.createRef<HTMLDivElement>();

    onMouseMoveThrottled = throttle(this.onMouseMove.bind(this), 50);

    render() {
        const { isResizing, rightRelativeWidth } = this.state;
        const { left, right } = this.props;

        return (
            <div ref={this.containerRef} className={BLOCK}>
                {left(1 - rightRelativeWidth)}
                <div className={Bem.cls(BLOCK, 'gutter')} onMouseDown={this.onMouseDown}>
                    <div
                        className={Bem.cls(BLOCK, 'control', {
                            resizing: isResizing
                        })}
                    />
                </div>
                {right(rightRelativeWidth)}
            </div>
        );
    }

    private onMouseMove(event: MouseEvent<HTMLElement>) {
        const { minLeft, minRight } = this.props;
        const container = this.containerRef.current;

        if (!container) {
            return;
        }

        const leftViewportOffset = container.getBoundingClientRect().left;
        const containerWidth = container.offsetWidth;

        const leftContainerOffset = event.clientX - leftViewportOffset;
        let rightWidth = containerWidth - leftContainerOffset;
        const leftWidth = containerWidth - rightWidth;

        if (rightWidth < minRight) {
            rightWidth = minRight;
        }
        if (leftWidth < minLeft) {
            rightWidth = containerWidth - minLeft;
        }

        const rightRelativeWidth = rightWidth / containerWidth;

        this.setState({
            rightRelativeWidth
        });
    }

    private onMouseDown = (event: MouseEvent<HTMLElement>) => {
        event.preventDefault();

        this.setState({ isResizing: true });

        document.addEventListener('mousemove', this.onMouseMoveThrottled);
        document.addEventListener('mouseup', this.onMouseUp);
    };

    private onMouseUp = () => {
        this.setState({ isResizing: false });

        document.removeEventListener('mousemove', this.onMouseMoveThrottled);
        document.removeEventListener('mouseup', this.onMouseUp);
    };
}
